<template>
    <div class="r-auth-register">
        <y-form-title
            :title="formTitle"
            :description="formDescription"
            :description-link="formDescriptionLink"
            :color="color"
        />

        <y-loading
            :active="$wait.is('fetch-config')"
            position="relative"
            height="100%"
        >
            <y-validator
                v-if="!isEmpty(configs)"
                @submit="register"
            >
                <!-- Forms -->
                <y-form
                    v-if="formElementsArray && formElementsArray.length"
                    v-model="model"
                    :elements="formElementsArray"
                />

                <!-- Recaptcha -->
                <y-recaptcha
                    v-if="configs.recaptcha && configs.recaptcha.active"
                    ref="recaptcha"
                    :site-key="configs.recaptcha.key"
                    :size="configs.recaptcha.size"
                    @verify="beforeRegister"
                />

                <!-- Register Button -->
                <y-button
                    block
                    flat
                    :color="color"
                    type="submit"
                    loading-on="register-form"
                >
                    {{ $t('auth.register.button') }}
                </y-button>
            </y-validator>
        </y-loading>
    </div>
</template>

<script>
    import {
        YForm, YValidator, YInput,
    } from '@components';
    import AuthRegisterMixin from '@rogues/Auth/mixins/Register';
    import isEmpty from 'lodash.isempty';

    export default {
        name: 'RegisterFormBlock',

        components: {
            YForm,
            YValidator,
            // eslint-disable-next-line vue/no-unused-components
            YInput,
        },

        mixins: [
            AuthRegisterMixin,
        ],

        methods: {
            isEmpty,
        },
    };
</script>
